import { Box, Button } from '@mui/material';
import PageContainer from '../layout/PageContainer';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

export default function Landing() {
  const navigate = useNavigate();

  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [navigate, user]);

  return <PageContainer
    title="Rinn's Pantry"
  >
    <Box>
      <Button
        variant="contained"
        onClick={() => navigate('/login')}>
        Login
      </Button>
    </Box>
  </PageContainer>
}
